import ARSTimeLineIconSmall from './ARSTimeLineIconSmall';

export default ARSTimeLineIconSmall;
